export const AssetSubtypesSelectFieldStyles = {
  container: 'mb-14 w-80',
}
